import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Drawer, Form, Space, message } from "antd";
import { AiOutlineClose } from "react-icons/ai";
import { handleDeleteContactHobby } from "../../../../api/contacts";
import { useEffect } from "react";

export default function DeleteHobby({
  isVisible,
  setVisible,
  contact,
  selected,
}: any) {
  const [form] = Form.useForm();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleDeleteContactHobby,
    onSuccess: () => {
      message.success("Deleted Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      setVisible(false);
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    await mutate({ _id: contact?._id, hobby_id: selected });
  };

  useEffect(() => {}, [contact, selected]);

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">
            <span className="font-bold">DELETE : </span>
          </span>
          <div className="flex text-gray-500 px-2 uppercase">Hobby</div>
        </div>
      }
      placement={"right"}
      width={900}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <Form
        id="deleteContactHobby"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="">
          <div className="">
            Are you sure you want to{" "}
            <span className="text-red-600">Delete</span>
          </div>

          <div className="flex flex-col my-4">
            <div className="">Hobby : {selected || ""}</div>
          </div>
        </div>

        <Form.Item>
          <Button danger type="primary" htmlType="submit" loading={isLoading}>
            Delete
          </Button>
          <Button
            danger
            htmlType="button"
            className="mx-2"
            onClick={() => setVisible(false)}
          >
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
